import type { SourceValue } from '../sources';

const SOURCE_LIMIT_WITH_FILTERS = 100;

export const getPostsLimit = (source: SourceValue, filtersKey: string[]) => {
  if (filtersKey.length > 0) {
    const limit =
      source?._customPostsLimit ?? source?._customWidgetDataPostsLimit;

    return limit ?? SOURCE_LIMIT_WITH_FILTERS;
  }

  return null;
};
